/* global AmCharts, chartLanguage, bocAmchart */

/**
 * @typedef {{bocSettings: {series, ga, addExport, lookup}, listeners, export}} AMConfig
 */

/**
 * Apply BOC settings to a export menu of the chart
 * @param {AMConfig} chartSettings The chart options
 * @returns {void}
 */
bocAmchart.addResizeUpdateListener = function (chartSettings) {
    // Add scrollbar change event.
    chartSettings.listeners.push({
        "event": "zoomed",
        "method": function (event) {
            bocAmchart.vars = bocAmchart.vars || {};
            bocAmchart.vars[event.chart.bocSettings.id] = bocAmchart.vars[event.chart.bocSettings.id] || {};
            if (!event.chart.bocSettings.id) {
                // Help troubleshoot settings
                // eslint-disable-next-line no-console
                console.log("Chart ID is not set on bocSettings for chart:", event.chart.titles[0].text);
            } else {
                var possibleIndexes = [
                    'startDate',
                    'endDate',
                    'startIndex',
                    'endIndex'
                ];
                possibleIndexes.forEach(function (property) {
                    if (event.hasOwnProperty(property)) {
                        bocAmchart.vars[event.chart.bocSettings.id][property] = event[property];
                    }
                });
            }
        }
    });
};

/**
 * Delete export menu later in the porocess, based on loaded data
 * @param {AMConfig} chart The chart options
 * @returns {void}
 */
bocAmchart.deleteExportMenu = function (chart) {
    if (chart.hasOwnProperty("export")) {
        delete (chart.export);
    }
    if (chart.hasOwnProperty("AmExport")) {
        delete (chart.AmExport);
    }
    chart.validateNow(false, true);
};

/**
 * Apply BOC settings to a export menu of the chart
 * @param {AMConfig} chartSettings The chart options
 * @returns {void}
 */
bocAmchart.updateExportMenu = function (chartSettings) {
    var pad2 = function (num) {
        return num < 10 ? '0' + num : num;
    };
    var shortDate = function (date) {
        return date.getFullYear() + "-" + pad2((date.getMonth() + 1)) + '-' + pad2(date.getDate());
    };
    var valet = function (event, item) {
        // Get the data range, if it's not a lookup or the range value is outside input range then set it to the initial start/end.
        var start, end, startDate, endDate;
        var chartId = chartSettings.bocSettings.id;

        // Make sure we deal with the date chart
        if (window[chartId].firstTime && window[chartId].lastTime) {
            startDate = new Date(window[chartId].firstTime);
            endDate = new Date(window[chartId].lastTime);
            if (!item.lookup || bocAmchart.vars[chartId]['startDate'] < startDate) {
                start = shortDate(startDate);
            } else {
                start = shortDate(bocAmchart.vars[chartId]['startDate']);
            }
            if (!item.lookup || bocAmchart.vars[chartId]['endDate'] > endDate) {
                end = shortDate(endDate);
            } else {
                end = shortDate(bocAmchart.vars[chartId]['endDate']);
            }
        }

        // Add the link, click it, then remove it.
        var link = document.createElement("a");
        link.href = window.valet_url + "observations/" + chartSettings.bocSettings.series + "/" + item.type;

        // Make sure we deal with the date chart
        if (window[chartId].firstTime && window[chartId].lastTime) {
            link.href += "?start_date=" + start + "&end_date=" + end;
        }
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    var labels = AmCharts.translations.export[chartLanguage];
    // Export menu items.
    var menu = [
        {
            "label": labels['menu.label.save.image'],
            "class": "amcharts-ga-event",
            "menu": ["PNG", "JPG", "SVG"]
        },
        {
            "label": labels['menu.label.draw'],
            "class": "amcharts-ga-event",
            "action": "draw",
            "menu": [{
                "class": "export-drawing",
                menu: [{
                    "label": labels["menu.label.draw.add"],
                    "menu": [{
                        "label": labels["menu.label.draw.shapes"],
                        "action": "draw.shapes"
                    }, {
                        "label": labels["menu.label.draw.text"],
                        "action": "text"
                    }]
                }, {
                    "label": labels["menu.label.draw.change"],
                    menu: [{
                        "label": labels["menu.label.draw.modes"],
                        "action": "draw.modes"
                    }, {
                        "label": labels["menu.label.draw.colors"],
                        "action": "draw.colors"
                    }, {
                        "label": labels["menu.label.draw.widths"],
                        "action": "draw.widths"
                    }, {
                        "label": labels["menu.label.draw.opacities"],
                        "action": "draw.opacities"
                    }, "UNDO", "REDO"]
                }, {
                    "label": labels["menu.label.save.image"],
                    menu: ["PNG", "JPG", "SVG"]
                }, "PRINT", "CANCEL"]
            }]
        },
        {
            "label": labels['menu.label.print'],
            "class": "amcharts-ga-event",
            "format": "PRINT"
        }
    ];

    var downloadAll = {
        "label": labels['menu.label.save.data'],
        "menu": [
            {
                "label": "CSV",
                "type": "csv",
                "class": "amcharts-ga-event",
                "click": valet
            },
            {
                "label": "JSON",
                "type": "json",
                "class": "amcharts-ga-event",
                "click": valet
            },
            {
                "label": "XML",
                "type": "xml",
                "class": "amcharts-ga-event",
                "click": valet
            }
        ]
    };

    var downloadSelected = {
        "label": labels['menu.label.save.visible'],
        "menu": [
            {
                "label": "CSV",
                "type": "csv",
                "class": "amcharts-ga-event",
                "click": valet,
                "lookup": true
            },
            {
                "label": "JSON",
                "type": "json",
                "class": "amcharts-ga-event",
                "click": valet,
                "lookup": true
            },
            {
                "label": "XML",
                "type": "xml",
                "class": "amcharts-ga-event",
                "click": valet,
                "lookup": true
            }
        ]
    };

    if (chartSettings.bocSettings.downloadOnly === true) {
        //only show the download All
        menu = [downloadAll];
    } else {
        menu.splice(1, 0, downloadAll);
    }

    if (chartSettings.bocSettings.lookup === true && (chartSettings.type === "serial"
        && (!chartSettings.bocSettings.args.hasOwnProperty('type') || chartSettings.bocSettings.args.type === "time")
    )) {
        // Add option to download only visible data.
        menu.splice(2, 0, downloadSelected);
    }

    // Add the export menu defaults.
    var imageName = "BoC_Chart";

    if (typeof chartSettings.bocSettings.series !== "undefined") {
        imageName = chartSettings.bocSettings.series;
    } else if (chartLanguage && chartLanguage !== "en") {
        imageName = "BdC_Graphique";
    }


    chartSettings.export = jQuery.extend({
        "enabled": true,
        "fileName": imageName,
        "drawing": {
            "autoClose": false
        },
        "menu": [{
            "class": "export-main",
            "menu": menu
        }],
        "libs": {
            "resources": ["fabric.js/fabric.min.js", "FileSaver.js/FileSaver.min.js"],
            "namespaces": {
                "fabric.min.js": "fabric",
                "FileSaver.min.js": "saveAs"
            }
        },
        "legend": {
            "position": "bottom"
        }
    }, chartSettings.export);
};
